export default "__VITE_ASSET__Ban3OpVZ__"